<template>
  <div class="full-height-wrapper">

    <notifications group="notification"/>
    <ProductInfoDialog ref="product_info_dialog"></ProductInfoDialog>

    <modal
        name="stage-info"
        transition="nice-modal-fade"
        :min-width="100"
        :min-height="400"
        :adaptive="true"
        :scrollable="true"
        :reset="false"
        width="100%"
        height="100%"
        @before-open="beforeOpenStageModal"
    >
      <button
          :title="`Close`"
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          @click="$modal.hide('stage-info')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="col-md-12" v-if="question">
        <Info :popupMode="true" :survey="survey" :current="cur_pos" :question="question" :total="max_pos"
              @download_image="downloadImage"></Info>
      </div>


      <Question
          v-if="question"
          id="question_block"
          :survey="survey"
          :question="question"
          :questions="questions"
          :cur_pos="cur_pos"
          :max_pos="max_pos"
          @product_click="showProductPopUp"
          @stage_click="showStagePopUp"
          @next="onClickNext"
          @prev="onClickPrev"
          @answer="takeAnswer"
          @endSurvey="hideModal"
      ></Question>
    </modal>

    <SwissTournament
        v-show="swiss_started"
        ref="swiss"
        :questions="questions_for_swiss"
        @swiss_done="onSwissDone"
    ></SwissTournament>

    <div v-show="refinement_started" class="container">
      <div class="row">
        <div class="col-md-12">
          <RefinementTournament
              ref="refinement"
              @refinement-done="onRefinementDone"
              @product-click="showProductPopUp"
          ></RefinementTournament>
        </div>
      </div>
    </div>
    <div v-if="!(swiss_started || refinement_started)" id="app_survey" class="full-height-wrapper">
      <div v-if="survey && survey.survey_type === 'if_else'">
        <IfElseSurvey
            :survey="survey"
            @endSurvey="endSurvey"
        ></IfElseSurvey>
      </div>
      <div v-else-if="survey && question" class="question container question-container">

        <Info :survey="survey" :current="cur_pos" :question="question" :total="max_pos"
              @download_image="downloadImage">

        </Info>

        <Question
            ref="question_component"
            id="question_block"
            :survey="survey"
            :question="question"
            :questions="questions"
            :cur_pos="cur_pos"
            :max_pos="max_pos"
            @next="onClickNext"
            @prev="onClickPrev"
            @answer="takeAnswer"
            @endSurvey="tieBreak"
            @product_click="showProductPopUp"
            @stage_click="showStagePopUp"
        ></Question>
      </div>
      <div v-else class="spinner-wrapper">
        <div class="spinner-body"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'

import Vue from 'vue'
import axios from 'axios'
import SwissTournament from '@src/components/survey/SwissTournament.vue'
import RefinementTournament from '@src/components/survey/RefinementTournament.vue'
import Question from '@src/components/survey/Question.vue'
import Info from '@src/components/survey/Info.vue'
import ProductInfoDialog from '@src/components/products/ProductInfoDialog.vue'
import IfElseSurvey from '@src/components/survey/ifElseSurvey/IfElseSurvey.vue'

export default {
  name: 'SurveyApp',
  components: {
    SwissTournament,
    RefinementTournament,
    ProductInfoDialog,
    Question,
    Info,
    IfElseSurvey
  },
  props: {
    surveyId: {
      type: Number,
      default: null,
    },
    customerPrefix: {
      type: String,
      default: '',
    },
    adminMode: {
      type: Boolean,
      default: false,
    },
    userRole: {
      type: String,
      default: '',
    },
    anonymousMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {

      swiss_started: false,
      refinement_started: false,

      question_for_popup: false,
      questions_for_swiss: [],

      groups_for_swiss: [],
      current_swiss_group: null,
      swissGroupsGenerator: null,
    }
  },
  computed: {
    survey_url() {
      const url = process.env.VUE_APP_SURVEYS_API_URL
      return this.brandedUrl(`${url}${this.surveyId}/`)
    },
    favorites_api_url() {
      const url = process.env.VUE_APP_FAVIRUTES_API_URL
      return this.brandedUrl(url)
    },
    products_api_url() {
      const url = process.env.VUE_APP_PRODUCTS_API_URL
      return this.brandedUrl(url)
    },
    home_url() {
      return this.brandedUrl('/')
    },
    end_survey_url() {
      return this.brandedUrl(`/surveycreator/${this.survey.public_id}/end/`)
    },
    profile_url() {
      return this.brandedUrl('/accounts/profile/')
    },
    results_url() {
      return this.brandedUrl('/surveycreator/results/')
    },
    ...mapState({notifications_queue: 'notifications'}),
    // ...mapState('take_survey', ['commandMoveTo']),
    ...mapGetters(['brandedUrl']),
    ...mapGetters('take_survey', ['survey', 'questions', 'cur_pos', 'max_pos', 'question']),
    ...mapState('take_survey', ['isSurveyEnd']),
  },
  watch: {
    isSurveyEnd: {
      handler: function (val, oldVal) {
        if (val) {
          this.endSurvey()
        }
      },
      immediate: true,
      deep: true,
    },
    notifications_queue: {
      handler: function (val, oldVal) {
        const queueTop = val.queue[val.queue.length - 1]
        if (queueTop) {
          this.$notify({
            type: queueTop.type,
            text: queueTop.text,
            title: queueTop.title,
            group: 'notification',
          })
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // fetch survey/questions
    this.getData(this.surveyId)
  },
  created() {
    this.setUserRole(this.userRole)
    this.setUserMode(this.adminMode)
    this.setBrandingSlug(this.customerPrefix)

    window.addEventListener('keyup', this.navigate)
  },
  methods: {
    ...mapMutations('take_survey', ['SET_COMMAND_DO_SUBMIT']),
    ...mapMutations('take_survey', ['MOVE_NEXT', 'MOVE_PREV']),
    ...mapActions('take_survey', ['sendAnswer', 'moveTo', 'getData']),
    ...mapActions('products', ['selectProduct']),
    ...mapActions(['setUserRole', 'setUserMode', 'setBrandingSlug']),
    downloadImage() {
      window.location.href = this.question.image;
    },
    beforeOpenStageModal(event) {
      this.question_for_popup = event.params.question
    },
    showStagePopUp(question) {
      this.$modal.hide()
      this.$modal.show('stage-info', {question})
    },
    showProductPopUp(product) {
      this.$refs.product_info_dialog.show(product.product_id)
    },
    activateRefiniment() {
      const groups_for_refinement = []

      for (let i = 5; i > 3; i--) {
        const questions = this.questions.filter(
            (v) => Math.ceil(v.last_answer) === i
        )
        if (questions.length > 1) {
          groups_for_refinement.push({group: i, questions})
        }
      }

      this.$refs.refinement.activate(groups_for_refinement)
      this.refinement_started = true
      this.$modal.hide()
    },
    activateSwiss() {
      console.log(this.$refs.swiss)
      // this.$refs.swiss.prepareRounds();

      this.questions_for_swiss = []

      for (let i = 5; i > 3; i--) {
        const questions = this.questions.filter(
            (v) => Math.ceil(v.last_answer) === i
        )
        if (questions.length > 1) {
          let swiss_questions = questions

          if (i === 5) {
            swiss_questions = questions.slice(0, 5)
          } else {
            swiss_questions = questions.slice(0, 2)
          }
          this.groups_for_swiss.push({group: i, questions: swiss_questions})
        }
      }

      console.log('Groups for swiss is:')
      console.log(this.groups_for_swiss)

      this.swissGroupsGenerator = this.swissGroupsGeneratorFunc()

      console.log('Call ActivateNextSwissGroup')
      this.activateNextSwissGroup()

      // console.log(this.questions_for_swiss);
      this.swiss_started = true
    },
    * swissGroupsGeneratorFunc() {
      for (const group in this.groups_for_swiss) {
        console.log('next yield')
        yield this.groups_for_swiss[group]
      }
    },
    activateNextSwissGroup() {
      const i = this.swissGroupsGenerator.next()
      console.log('activateNextSwissGroup')
      console.log(i)

      if (i.done) {
        this.endSurvey()
        return null
      }
      console.log("This group is not done, let's take questions")
      console.log(`GROUP: ${i.value.group}`)
      console.log(i.value.questions)
      this.questions_for_swiss = i.value.questions
      this.$refs.swiss.activate(i.value.questions)
    },
    navigate(event) {
      if (event.key === 'ArrowLeft') {
        this.decPos()
      }

      if (event.key === 'ArrowRight') {
        this.incPos()
      }

      if (event.key === 'ArrowDown') {
        this.cur_pos = this.max_pos
      }

      if (event.key === 'ArrowUp') {
        this.cur_pos = 0
      }

      if (
          event.key === '1' ||
          event.key === '2' ||
          event.key === '3' ||
          event.key === '4' ||
          event.key === '5'
      ) {
        if (this.question.type === 'select_image') {
          this.takeAnswer({'answer': event.key})
        }
      }
    },
    answers(event) {
      this.takeAnswer({'answer': event.key})
    },
    onClickNext() {
      this.incPos()
    },
    onClickPrev() {
      this.decPos()
    },
    incPos() {
      if (this.cur_pos < this.max_pos) {
        if (this.survey.survey_type === 'custom_variables') {
          this.SET_COMMAND_DO_SUBMIT(true)
        } else {
          this.MOVE_NEXT()
        }
      } else {
        if (!this.refinement_started) {
          this.activateRefiniment()
        }
      }
    },
    decPos() {
      if (this.cur_pos > 0) {
        this.MOVE_PREV()
      }
    },
    takeAnswer(answer_data) {
      const vm = this
      console.log(vm)
      // old
      this.questions[this.cur_pos].last_answer = answer_data.answer
      // new
      this.questions[this.cur_pos].answer = answer_data
      this.postAnswer(this.questions[this.cur_pos].id, answer_data)

      if (vm.cur_pos + 1 >= vm.questions.length) {
        if (!this.refinement_started) {
          vm.activateRefiniment()
        }
      } else {
        // vm.incPos()
      }
    },
    onRefinementDone(results) {
      const formData = new FormData()

      for (const g of results) {
        formData.append('groups[]', g.group)
        formData.append('ids[]', g.questions)
      }

      axios
          .post(`${this.survey_url}refinement_answers/`, formData, {
            headers: {'Content-Type': 'multipart/form-data'},
            xsrfCookieName: 'csrftoken',
            xsrfHeaderName: 'X-CSRFToken',
          })
          .then((response) => {
            this.endSurvey()
          })
          .catch((e) => {
            console.log(e)
          })
    },
    onSwissDone(results) {
      console.log('----- ## -----')
      console.log(results)
      console.log('----- ## -----')

      const max_score = Math.max.apply(
          Math,
          results.map((o) => o.score)
      )

      let prevScore = null

      for (const r of results) {
        if (parseFloat(r.score) < max_score) {
          const old_answer_int = Math.ceil(r.data.last_answer)

          console.log(`Old val = ${parseInt(old_answer_int)}`)

          let corrected_val =
              parseInt(old_answer_int) - parseFloat(max_score - r.score) * 0.05

          r.corrected_val = corrected_val

          if (prevScore && prevScore === corrected_val) {
            corrected_val -= 0.05
            r.corrected_val = corrected_val
          }

          // can't be less then prev answer (4 can't go to 2.9)
          if (corrected_val <= old_answer_int - 1) {
            corrected_val = old_answer_int - 0.95
          }

          console.log(`New val = ${parseFloat(corrected_val)}`)
          this.postAnswer(r.data.id, {'answer': corrected_val})
          prevScore = corrected_val
        }
      }

      this.activateNextSwissGroup()
    },
    tieBreak() {
      this.activateRefiniment()
    },
    hideModal() {
      this.$modal.hide('stage-info')
    },
    endSurvey() {
      let url = null

      url = `${this.end_survey_url}`
      window.location = url

      // if (this.anonymousMode) {
      //   // url = `${this.results_url}${this.surveyId}/`
      //
      //   this.$swal({
      //     title: 'Your Input Matters',
      //     html:
      //         'Create an account to download and export your results and be part of the journey as we design a great place to work',
      //     confirmButtonText: "Yes, let's do it!",
      //     showCloseButton: true,
      //     showCancelButton: true,
      //     focusConfirm: false,
      //     icon: 'info',
      //   }).then((result) => {
      //     if (result.value) {
      //       url = `${this.end_survey_url}`
      //       window.location = url
      //     } else {
      //       url = `${this.home_url}`
      //       window.location = url
      //     }
      //   })
      // } else {
      //   url = `${this.end_survey_url}`
      //   window.location = url
      // }
    },
    shuffleDeck() {
      for (let i = this.questions.length - 1; i > 0; i--) {
        const randomIndex = Math.floor(Math.random() * i)
        const temp = this.questions[i]
        Vue.set(this.questions, i, this.questions[randomIndex])
        Vue.set(this.questions, randomIndex, temp)
      }
    },
    postAnswer(q_id, answer_data) {
      this.sendAnswer({'surveyId': this.survey.id, 'questionId': q_id, 'answerData': answer_data})
    },
  },
}
</script>

<style lang="scss">
.xwrap {
  width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.section {
  padding-top: 20px;
  margin-top: 30px;
}

.section__header {
  margin-top: 10px;
  margin-bottom: 25px;
  font-size: 2em;
}

.close {
  position: absolute;
  top: 18px;
  right: 50px;
  z-index: 999999;
  font-size: 48px;
}

.xwrap {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 0;
  margin: 0 auto;
  overflow: hidden;
}

.full-height-wrapper {
  display: flex;
  flex: 1;
  //flex-direction: column;
  justify-content: center;
}

.image-with-products {
  margin: 10px;
}

@keyframes flash {
  0% {
    color: black;
    opacity: 0.3;
  }
  50% {
    font-size: 20px;
    color: black;
    opacity: 0.5;
  }
  100% {
    color: black;
    opacity: 1;
  }
}

#question_block {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 100%;
  height: 100%;
}

#question_block.fancybox-content {
  padding: 10px;
}

.fancybox-container {
  z-index: 100;
}

.fancybox-slide {
  display: flex;
}

.fancybox-content {
  display: flex !important;
}

.stage {
  display: flex;
  flex-direction: column;
  align-items: center;
}

    @media(max-width: 768px) {
      .question-container {
        width: 100%;
      }
    }


.question {
  display: flex;
  flex-direction: column;
  min-width: auto;
  height: 100%;
  margin: 0 auto;

}

.question-info {
  margin-top: 0;
  margin-bottom: 20px;
  text-align: center;
}

.question-info__header {
  color: #444;
}

.question-info__description {
  padding: 5px 0px;
}

.question-area {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 100px;
  //padding: 5px;
  text-align: center;
}

.question-area .image-with-products {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.question-area_text-question {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.question-area_p {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 500px;
  min-height: 300px;
  font-size: 30px;
  line-height: 1.5em;
  color: gray;
}

.question-area_img {
  flex-shrink: 0;
  min-width: 300px;
}

.question-area_img img {
  max-width: 250px;
  max-height: 200px;
}

.control-panel {
  display: flex;
  flex-direction: row;
  flex-shrink: 1;
  justify-content: space-around;

  margin: 10px auto 15px;
  margin-top: 10px;
  margin-bottom: 15px;

}

.control-panel__section {
  // border-spacing: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  // flex-shrink: 1;
  width: 100%;
}

.control-panel__section--left {
  flex: 0;
}

.control-panel__section--right {
  flex: 0;
}

.control-panel__element {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
}

.control-panel__btntext {
  display: block;
  width: 100%;
}

.control-panel__btn {
  display: flex;
  align-items: center;
  width: 50px;
  height: 50px;
  margin: 0 2px 0 2px;
  // vertical-align: middle;
  font-weight: bold;
  color: #333;
  text-align: center;
  text-align: center;
  text-decoration: none;
  background-color: #eee;
  border: 1px solid #98c7e3;
  border-radius: 50px;
  transition: background-color 0.2s linear 0s;
}

.control-panel__btn--answers {
  min-width: 50px;
}

.control-panel__helptext {
  display: block;
  width: 100%;
  max-width: 50px;
  margin-top: 5px;
  font-size: 12px;
  color: gray;
  text-align: center;
}

.no-touch .control-panel__btn:hover {
  background-color: #98c7e3;
}

.control-panel__btn_prev,
.control-panel__btn_next {
  width: 100px;
}


  @media only screen and (max-width: 400px) {
    .control-panel__btn_prev,
    .control-panel__btn_next {
      min-width: auto;
    }

  }

.control-panel__btn_end,
.control-panel__btn_products {
  width: 150px;
}

.control-panel__btn--active {
  border-color: #d58512;
}

.control-panel__btn_products--disabled {
  opacity: 0;
}

.control-panel__btn_end,
.control-panel__btn_products {
  max-width: 130px;
}

@media (max-width: 767px) {
  .control-panel.old_survey_type {
    margin-right: 5px;
    margin-left: 5px;
    flex-wrap: wrap;
    justify-content: space-between;


    .control-panel__btn--answers {
      width: 100%;
      min-width: 25px;
      max-width: auto;
    }

    .control-panel__element {
      width: 100%;
      min-width: 25px;
      max-width: 50px;
      margin: 1px;
    }

    .control-panel__element--nav {
      min-width: 100px;
    }

    .control-panel__section {
      justify-content: space-around;
    }

    .control-panel__section:nth-child(2) {
      flex-grow: 2;
      width: 100%;
      margin: 0 auto;
    }

    .control-panel__section:nth-child(1),
    .control-panel__section:nth-child(3) {
      flex: 0;
      order: 2;
    }
  }
}

a.control-panel__btn,
a.control-panel__btn:hover {
  text-decoration: none;
}

.control-panel__btn--hot {
  text-decoration: none;
  background-color: #98c7e3;
  border-color: #0a92e0;
  animation-name: flash;
  animation-duration: 0.5s;
  animation-timing-function: linear;
}

.control-panel__btn--disabled {
  background-color: #eee !important;
}

.control-panel__btn--disabled:hover {
  background-color: #eee !important;
}
</style>
